import React, { useContext, Suspense, useEffect, lazy } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import "../../admin/layout/adminsOperator.css";
import Main from "../../admin/layout/Main";
import routes from "../routes";
// import routesClient from "../routes/routesClient";
import Header from "../../admin/components/header/Header";
import Sidebar from "../Components/sidebar/Sidebar";
import { SidebarContext } from "../../admin/context/SidebarContext";
import ThemeSuspense from "../../admin/components/theme/ThemeSuspense";
import { BiPhoneCall } from "react-icons/bi";

//const Page404 = lazy(() => import("../pages/404"));
const Layout = () => {
  const { isSidebarOpen, closeSidebar } = useContext(SidebarContext);

  let location = useLocation();

  const params = window.location.href.split("/");

  useEffect(() => {
    closeSidebar();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);


  return (
    <>
      {/* {params[3] == "user" ? (
                <Suspense fallback={<ThemeSuspense />} className="newClass">
                    <Switch>
                        {routes?.map((route, i) => {
                            return route.component ? (
                                <Route
                                    key={i}
                                    exact={true}
                                    path={`${route.path}`}
                                    render={(props) => <route.component {...props} />}
                                />
                            ) : null;
                        })}
                        <Redirect exact from="/" to="/user/profile" />
                    </Switch>
                </Suspense>
            ) : ( */}
      <>
        <div
          className={`flex h-screen bg-gray-50 ${isSidebarOpen && "overflow-hidden"
            }`}
        >
          <Sidebar />
          <div className="flex flex-col flex-1 max-w-full">
            <Header />

            <Main className="adminMainLayClass">
              <Suspense
                fallback={<ThemeSuspense />}
                className="overflow-x-scroll newClass"
              >
                <Switch>
                  {routes?.map((route, i) => {
                    return route.component ? (
                      <Route
                        key={i}
                        exact={true}
                        path={`${route.path}`}
                        render={(props) => <route.component {...props} />}
                      />
                    ) : null;
                  })}
                  <Redirect exact from="/" to="/user/profile" />
                </Switch>
              </Suspense>
            </Main>
          </div>
        </div>
      </>
      {/* )} */}
    </>
  );
};

export default Layout;
